<div class="campaigns-container">
  <!-- Dashboard (opcional, toggle) -->
  <app-campaign-dashboard 
    *ngIf="showDashboard"
    [campaigns]="campaigns"
  ></app-campaign-dashboard>

  <!-- Tabla de Campañas -->
  <p-card>
    <div class="row">
      <div class="col-12">
        <h1 class="mb-3">Campañas</h1>
        <p class="mb-3 text-color-secondary">
          Monitorea en tiempo real las campañas de cobranza programadas y ejecutadas. 
          Visualiza métricas de efectividad, estados de ejecución y resultados por canal. 
          Auto-actualización cada 30 segundos.
        </p>
      </div>
    </div>

    <!-- Error State -->
    <div *ngIf="hasError" class="error-container">
      <div class="error-content">
        <i class="fa-solid fa-exclamation-triangle error-icon"></i>
        <h3>Oops! Algo salió mal</h3>
        <p>{{ errorMessage }}</p>
        <button pButton label="Reintentar" icon="pi pi-refresh" (click)="retry()"></button>
      </div>
    </div>

    <!-- Content -->
    <app-main-table *ngIf="!hasError"
      [columns]="columns"
      [actions]="actions"
      [apiService]="apiCampaignsService"
      [additionalMainActions]="additionalMainActions"
      (onAction)="handleTableAction($event)"
      (onMainAction)="handleMainAction($event)"
    ></app-main-table>
  </p-card>

  <!-- Toast para mensajes -->
  <p-toast></p-toast>

  <!-- Dialog de confirmación -->
  <p-confirmDialog></p-confirmDialog>
</div>
